module.exports = __webpack_public_path__ + "assets/img/home_QRCode.21848b96.png";